import {Component, Input} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false
})
export class ConfirmationDialogComponent {
  @Input() title: string;
  @Input() description: string;

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  close(answer: boolean) {
    this.dialogRef.close(answer);
  }
}
